var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fab-container"},[_c('div',{staticClass:"fab-btn",on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":"img/complete-btn.svg","alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }